var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("b-loading", {
        attrs: {
          "is-full-page": _vm.isFullPage,
          active: _vm.isLoading,
          "can-cancel": true
        },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sidebar-fixed bg-white sidebar",
          attrs: { id: "sidebarMenu" }
        },
        [
          _c("div", { staticClass: "sidebar-header" }, [
            _c("h5", [_vm._v("Search")]),
            _vm._v(" "),
            _c(
              "a",
              { attrs: { href: "", id: "sidebarMenuClose" } },
              [
                _c("feather", {
                  staticClass:
                    "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                  attrs: { type: "x" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("vueCustomScrollbar", [
            _c(
              "div",
              { staticClass: "sidebar-body" },
              [
                _c("ul", { staticClass: "sidebar-nav" }, [
                  _c(
                    "div",
                    { attrs: { id: "app" } },
                    [
                      _c("v-app", { attrs: { id: "inspire" } }, [
                        _c(
                          "div",
                          [
                            _c("v-date-picker", {
                              attrs: { width: "200", type: "month" },
                              on: {
                                "click:month": function($event) {
                                  return _vm.classifyData()
                                }
                              },
                              model: {
                                value: _vm.picker,
                                callback: function($$v) {
                                  _vm.picker = $$v
                                },
                                expression: "picker"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm._l(_vm.inputSearchForms, function(form, i) {
                  return _c("ul", { staticClass: "sidebar-nav" }, [
                    i === 0
                      ? _c("li", { staticClass: "nav-label mg-b-10-f" }, [
                          _vm._v("Input Search")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        {
                          staticClass: "d-block",
                          attrs: { for: "formGroupExampleInput" }
                        },
                        [_vm._v(_vm._s(form.name))]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: form.value,
                            expression: "form.value"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: form.id,
                          placeholder: form.name
                        },
                        domProps: { value: form.value },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.textKeyupEvent($event)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(form, "value", $event.target.value)
                          }
                        }
                      })
                    ])
                  ])
                }),
                _vm._v(" "),
                _vm._l(_vm.inputDeptForms, function(form, i) {
                  return _c("ul", { staticClass: "sidebar-nav" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "d-block",
                            attrs: { for: "formGroupExampleInput" }
                          },
                          [_vm._v(_vm._s(form.name))]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-field",
                          [
                            _c("b-autocomplete", {
                              ref: "deptName",
                              refInFor: true,
                              attrs: {
                                id: form.id,
                                data: _vm.filteredDeptArray,
                                placeholder: form.name
                              },
                              on: {
                                select: function(option) {
                                  return (_vm.selected = option)
                                }
                              },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.classifyData()
                                }
                              },
                              model: {
                                value: _vm.deptName,
                                callback: function($$v) {
                                  _vm.deptName = $$v
                                },
                                expression: "deptName"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                }),
                _vm._v(" "),
                _vm._l(_vm.inputCompanyForms, function(form, i) {
                  return _c("ul", { staticClass: "sidebar-nav" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "d-block",
                            attrs: { for: "formGroupExampleInput" }
                          },
                          [_vm._v(_vm._s(form.name))]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-field",
                          [
                            _c("b-autocomplete", {
                              ref: "companyName",
                              refInFor: true,
                              attrs: {
                                id: form.id,
                                data: _vm.filteredCompArray,
                                placeholder: form.name
                              },
                              on: {
                                select: function(option) {
                                  return (_vm.selected = option)
                                }
                              },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.classifyData()
                                }
                              },
                              model: {
                                value: _vm.companyName,
                                callback: function($$v) {
                                  _vm.companyName = $$v
                                },
                                expression: "companyName"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                }),
                _vm._v(" "),
                _vm._l(_vm.dateRangeSearchForms, function(form, i) {
                  return _c("ul", { staticClass: "sidebar-nav mg-t-35-f" }, [
                    i === 0
                      ? _c("li", { staticClass: "nav-label mg-b-10-f" }, [
                          _vm._v("Date Range Search")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "d-block",
                        attrs: { for: "formGroupExampleInput" }
                      },
                      [_vm._v(_vm._s(form.name))]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "nav-item" },
                      [
                        _c("date-picker", {
                          staticClass: "form-control",
                          attrs: {
                            config: _vm.datePickerOptions,
                            autocomplete: "off",
                            placeholder: "From date",
                            id: form.fid,
                            "aria-label": "Search",
                            ignoreReadonly: ""
                          },
                          on: { "dp-change": _vm.dateKeyupEvent },
                          model: {
                            value: form.fvalue,
                            callback: function($$v) {
                              _vm.$set(form, "fvalue", $$v)
                            },
                            expression: "form.fvalue"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "nav-item" },
                      [
                        _c("date-picker", {
                          staticClass: "form-control",
                          attrs: {
                            config: _vm.datePickerOptions,
                            autocomplete: "off",
                            placeholder: "To date",
                            id: form.eid,
                            "aria-label": "Search",
                            ignoreReadonly: ""
                          },
                          on: { "dp-change": _vm.dateKeyupEvent },
                          model: {
                            value: form.evalue,
                            callback: function($$v) {
                              _vm.$set(form, "evalue", $$v)
                            },
                            expression: "form.evalue"
                          }
                        })
                      ],
                      1
                    )
                  ])
                }),
                _vm._v(" "),
                _vm._l(_vm.checkboxSearchForms, function(form, i) {
                  return _c(
                    "ul",
                    { staticClass: "sidebar-nav mg-t-35-f" },
                    [
                      i === 0
                        ? _c("li", { staticClass: "nav-label mg-b-10-f" }, [
                            _vm._v("Checkbox Search")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: " d-block",
                          attrs: { for: "formGroupExampleInput" }
                        },
                        [_vm._v(_vm._s(form.name))]
                      ),
                      _vm._v(" "),
                      _vm._l(form.subs, function(form1, i) {
                        return _c(
                          "div",
                          {
                            staticClass:
                              "custom-control custom-checkbox mg-b-7",
                            attrs: { id: form.id }
                          },
                          [
                            _c("input", {
                              staticClass: "custom-control-input",
                              attrs: { type: "checkbox", id: form1.codeCode },
                              domProps: { value: form1.codeCode },
                              on: { click: _vm.checkClickEvent }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "custom-control-label",
                                attrs: { for: form1.codeCode }
                              },
                              [_vm._v(_vm._s(form1.codeName))]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                })
              ],
              2
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "content content-components overflow-hidden" }, [
        _c("div", { staticClass: "pd-x-0 pd-lg-x-10 pd-xl-x-0" }, [
          _c(
            "div",
            {
              staticClass:
                "d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30"
            },
            [
              _c("div", [
                _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
                  _c(
                    "ol",
                    { staticClass: "breadcrumb breadcrumb-style1 mg-b-10" },
                    [
                      _c("li", { staticClass: "breadcrumb-item" }, [
                        _vm._v(_vm._s(this.mainName))
                      ]),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass: "breadcrumb-item active",
                          attrs: { "aria-current": "page" }
                        },
                        [_vm._v(_vm._s(this.subName) + " List")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "mg-b-0 tx-spacing--1" }, [
                    _vm._v(_vm._s(this.subName) + " List")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "card-header2 col-lg-8 col-xl-7 pd-y-15 pd-x-20 d-flex align-items-center justify-content-end"
                },
                [
                  this.$route.name != "orderconfirms" &&
                  this.$route.name != "results"
                    ? _c(
                        "router-link",
                        {
                          staticClass:
                            "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5",
                          attrs: {
                            to: {
                              name: this.$route.name + "_detail",
                              params: {
                                mid: this.properties.mid,
                                type: "detail"
                              }
                            }
                          }
                        },
                        [
                          _c("feather", {
                            staticClass:
                              "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                            attrs: { type: "file" }
                          }),
                          _vm._v("Create")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row row-xs" }, [
            _c("div", {
              staticClass: "fixedHeader col-lg-12 mg-t-10 b-table",
              class: [_vm.b_scroll ? "display-inline-block" : "display-none"]
            }),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-12 mg-t-10" }, [
              _c(
                "section",
                [
                  _c(
                    "b-field",
                    { attrs: { grouped: "", "group-multiline": "" } },
                    [
                      _c(
                        "b-select",
                        {
                          attrs: { disabled: !_vm.isPaginated },
                          model: {
                            value: _vm.perPage,
                            callback: function($$v) {
                              _vm.perPage = $$v
                            },
                            expression: "perPage"
                          }
                        },
                        [
                          _c("option", { attrs: { value: "20" } }, [
                            _vm._v("20")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "50" } }, [
                            _vm._v("50")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "100" } }, [
                            _vm._v("100")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "200" } }, [
                            _vm._v("200")
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "section",
                [
                  _c(
                    "b-table",
                    {
                      staticClass: "overflow-x-hidden",
                      attrs: {
                        data: _vm.isEmpty ? [] : _vm.data,
                        loading: _vm.loading,
                        paginated: "",
                        hoverable: "",
                        striped: "",
                        "backend-pagination": "",
                        total: _vm.total,
                        "per-page": _vm.perPage,
                        "aria-next-label": "Next page",
                        "aria-previous-label": "Previous page",
                        "aria-page-label": "Page",
                        "aria-current-label": "Current page",
                        "backend-sorting": "",
                        "default-sort": [_vm.sortField, _vm.sortOrder],
                        id: "listTable"
                      },
                      on: { "page-change": _vm.onPageChange, sort: _vm.onSort },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(props) {
                            return [
                              _c(
                                "b-table-column",
                                { attrs: { field: "no", label: "No" } },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(props.row.no) +
                                      "\n                            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.headers, function(form, i) {
                                return i == 0
                                  ? _c(
                                      "b-table-column",
                                      {
                                        key: i,
                                        attrs: {
                                          field: form.columnCode,
                                          label: form.columnName,
                                          centered: "",
                                          sortable: ""
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            attrs: { href: "#" },
                                            on: {
                                              click: function($event) {
                                                return _vm.goPage(
                                                  props.row.id,
                                                  props.row.stateCode,
                                                  props.row.creatorId
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                  \n                                 " +
                                                _vm._s(
                                                  props.row[form.columnCode]
                                                ) +
                                                "\n                              "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.headers, function(form, i) {
                                return i > 0
                                  ? _c(
                                      "b-table-column",
                                      {
                                        key: i,
                                        attrs: {
                                          field: form.columnCode,
                                          label: form.columnName,
                                          centered: "",
                                          sortable: ""
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                              " +
                                            _vm._s(props.row[form.columnCode]) +
                                            "\n                           "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              }),
                              _vm._v(" "),
                              _vm.mainName == "Result"
                                ? _c(
                                    "b-table-column",
                                    {
                                      attrs: {
                                        field: "read",
                                        label: "Read",
                                        centered: ""
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "#",
                                            id: props.index,
                                            "data-toggle": "modal",
                                            "data-animation":
                                              "effect-flip-horizontal"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.dialog3Handler(
                                                props.row
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("feather", {
                                            staticClass:
                                              "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                            attrs: { type: "more-horizontal" }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.mainName == "Result"
                                ? _c(
                                    "b-table-column",
                                    {
                                      attrs: {
                                        field: "qwrap",
                                        label: "QWRAP Report",
                                        centered: ""
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "#",
                                            id: props.index,
                                            "data-toggle": "modal",
                                            "data-animation":
                                              "effect-flip-horizontal"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.loadHtml(props.row.id)
                                            }
                                          }
                                        },
                                        [
                                          _c("feather", {
                                            staticClass:
                                              "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                            attrs: { type: "book-open" }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.mainName == "Result"
                                ? _c(
                                    "b-table-column",
                                    {
                                      attrs: {
                                        field: "research",
                                        label: "Research Report",
                                        centered: ""
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "#",
                                            id: props.index,
                                            "data-toggle": "modal",
                                            "data-animation":
                                              "effect-flip-horizontal"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.dialogHandler(
                                                props.row.id
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("feather", {
                                            staticClass:
                                              "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                            attrs: { type: "download" }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.mainName == "Result"
                                ? _c(
                                    "b-table-column",
                                    {
                                      attrs: {
                                        field: "sampleInfo",
                                        label: "Sample Info",
                                        centered: ""
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "#",
                                            id: props.index,
                                            "data-toggle": "modal",
                                            "data-animation":
                                              "effect-flip-horizontal"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.setLinkdialogHandler(
                                                props.row
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("feather", {
                                            staticClass:
                                              "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                            attrs: { type: "hard-drive" }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c("template", { slot: "empty" }, [
                        _c("section", { staticClass: "section" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content has-text-grey has-text-centered"
                            },
                            [_c("p", [_vm._v("Nothing here.")])]
                          )
                        ])
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("v-app", { attrs: { id: "inspire" } }, [
        _c(
          "div",
          [
            _c(
              "v-row",
              { attrs: { justify: "center" } },
              [
                _c(
                  "v-dialog",
                  {
                    staticStyle: { "z-index": "20001" },
                    attrs: { "max-width": "500px" },
                    model: {
                      value: _vm.researchReportDialog,
                      callback: function($$v) {
                        _vm.researchReportDialog = $$v
                      },
                      expression: "researchReportDialog"
                    }
                  },
                  [
                    _c(
                      "v-card",
                      [
                        _c("v-card-title", [
                          _vm._v(
                            "\n                            Research Report\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-card-text",
                          [
                            _c("v-select", {
                              attrs: {
                                items: _vm.select[this.properties.task],
                                label: "A Select Report Type",
                                "item-value": "text"
                              },
                              model: {
                                value: _vm.reportType,
                                callback: function($$v) {
                                  _vm.reportType = $$v
                                },
                                expression: "reportType"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-card-actions",
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "primary", text: "" },
                                on: {
                                  click: function($event) {
                                    _vm.researchReportDialog = false
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                Close\n                            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "primary",
                                  text: "",
                                  type: "button",
                                  loading: _vm.btnLoading
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.loadReport()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                Load\n                            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("v-app", { attrs: { id: "inspire" } }, [
        _c(
          "div",
          [
            _c(
              "v-row",
              { attrs: { justify: "center" } },
              [
                _c(
                  "v-dialog",
                  {
                    staticStyle: { "z-index": "20001" },
                    attrs: { "max-width": "570px", scrollable: "" },
                    model: {
                      value: _vm.dialog3,
                      callback: function($$v) {
                        _vm.dialog3 = $$v
                      },
                      expression: "dialog3"
                    }
                  },
                  [
                    _c(
                      "v-card",
                      [
                        _c(
                          "v-toolbar",
                          {
                            staticClass: "mb-2",
                            attrs: {
                              color: "indigo darken-5",
                              dark: "",
                              flat: ""
                            }
                          },
                          [
                            _c("v-toolbar-title", [_vm._v("Read Count")]),
                            _vm._v(" "),
                            _c("v-divider"),
                            _vm._v(" "),
                            _c("v-card-title", [
                              _c("h4", [_vm._v(_vm._s(_vm.readTask))])
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-card-text",
                          { staticStyle: { "max-height": "300px" } },
                          [
                            _c(
                              "v-list",
                              { attrs: { dense: "" } },
                              _vm._l(_vm.readList, function(item) {
                                return _c(
                                  "v-list-item",
                                  { key: item.key },
                                  [
                                    _c("v-list-item-content", [
                                      _vm._v(_vm._s(item.key) + ":")
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-item-content",
                                      { staticClass: "align-end" },
                                      [
                                        _vm._v(
                                          "\n                                            " +
                                            _vm._s(item.value) +
                                            "\n                                        "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-card-actions",
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "primary", text: "" },
                                on: {
                                  click: function($event) {
                                    _vm.dialog3 = false
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                Close\n                            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "v-app",
        { attrs: { id: "inspire" } },
        [
          _c(
            "div",
            [
              _c(
                "v-row",
                { attrs: { justify: "center" } },
                [
                  _c(
                    "v-dialog",
                    {
                      staticStyle: { "z-index": "20001" },
                      attrs: { "max-width": "570px", scrollable: "" },
                      model: {
                        value: _vm.linkDialog,
                        callback: function($$v) {
                          _vm.linkDialog = $$v
                        },
                        expression: "linkDialog"
                      }
                    },
                    [
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-toolbar",
                            {
                              staticClass: "mb-2",
                              attrs: {
                                color: "indigo darken-5",
                                dark: "",
                                flat: ""
                              }
                            },
                            [
                              _c(
                                "v-toolbar-title",
                                [
                                  _c("feather", {
                                    staticClass:
                                      "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                    attrs: { type: "link" }
                                  }),
                                  _vm._v("Sample Info ")
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-divider")
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-text",
                            { staticStyle: { "max-height": "500px" } },
                            [
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Company / Institution")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        ref: "company",
                                        attrs: {
                                          label: "Company / Institution"
                                        },
                                        model: {
                                          value: _vm.company,
                                          callback: function($$v) {
                                            _vm.company = $$v
                                          },
                                          expression: "company"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Date Of Sample Reception")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        ref: "receptionDate",
                                        attrs: {
                                          label: "Date Of Sample Reception"
                                        },
                                        model: {
                                          value: _vm.receptionDate,
                                          callback: function($$v) {
                                            _vm.receptionDate = $$v
                                          },
                                          expression: "receptionDate"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Report Type")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        ref: "rType",
                                        attrs: { label: "Report Type" },
                                        model: {
                                          value: _vm.rType,
                                          callback: function($$v) {
                                            _vm.rType = $$v
                                          },
                                          expression: "rType"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Target Region")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        ref: "targetRegion",
                                        attrs: { label: "Target Region" },
                                        model: {
                                          value: _vm.targetRegion,
                                          callback: function($$v) {
                                            _vm.targetRegion = $$v
                                          },
                                          expression: "targetRegion"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Requested Read Count")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        ref: "requestedRead",
                                        attrs: {
                                          label: "Requested Read Count"
                                        },
                                        model: {
                                          value: _vm.requestedRead,
                                          callback: function($$v) {
                                            _vm.requestedRead = $$v
                                          },
                                          expression: "requestedRead"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Rarefied Read Count")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        ref: "rarefiedRead",
                                        attrs: { label: "Rarefied Read Count" },
                                        model: {
                                          value: _vm.rarefiedRead,
                                          callback: function($$v) {
                                            _vm.rarefiedRead = $$v
                                          },
                                          expression: "rarefiedRead"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Type of Sequencer")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        ref: "sequencer",
                                        attrs: { label: "Sequencer" },
                                        model: {
                                          value: _vm.sequencer,
                                          callback: function($$v) {
                                            _vm.sequencer = $$v
                                          },
                                          expression: "sequencer"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Drive Link")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        attrs: { label: "LINK" },
                                        model: {
                                          value: _vm.driveLink,
                                          callback: function($$v) {
                                            _vm.driveLink = $$v
                                          },
                                          expression: "driveLink"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-actions",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "primary", text: "" },
                                  on: {
                                    click: function($event) {
                                      _vm.linkDialog = false
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                Close\n                            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "blue darken-1", text: "" },
                                  on: {
                                    click: function($event) {
                                      ;(_vm.linkDialog = false), _vm.setLink()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                Save\n                            "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-snackbar",
            {
              scopedSlots: _vm._u([
                {
                  key: "action",
                  fn: function(ref) {
                    var attrs = ref.attrs
                    return [
                      _c(
                        "v-btn",
                        _vm._b(
                          {
                            attrs: { color: "pink", text: "" },
                            on: {
                              click: function($event) {
                                _vm.snackBar = false
                              }
                            }
                          },
                          "v-btn",
                          attrs,
                          false
                        ),
                        [_vm._v("\n            Close\n          ")]
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.snackBar,
                callback: function($$v) {
                  _vm.snackBar = $$v
                },
                expression: "snackBar"
              }
            },
            [_vm._v("\n        " + _vm._s(_vm.snackBarMessage) + "\n        ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("v-overlay", { attrs: { value: _vm.overlay } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "center",
                      "flex-direction": "column"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { "margin-bottom": "10px" } },
                      [
                        _c("v-progress-circular", {
                          attrs: { indeterminate: "", size: "64" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("b", [_vm._v(_vm._s(_vm.downloadMsg))]),
                    _vm._v(" "),
                    _c("div"),
                    _vm._v(" "),
                    _c("div", [
                      _c("b", [
                        _vm._v(" " + _vm._s(_vm.downloadProgress) + " % ")
                      ])
                    ])
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b50445d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b50445d0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Common/List.vue
// module id = null
// module chunks = 